import * as yup from 'yup';
import NumberConverter from '../../../helper/ConvertPersionNumberToEnglish';

export const validationSchema = yup.object().shape({
  mobile: yup
    .string()
    .transform((value) => {
      if (!value) return value;
      return NumberConverter.toEnglishNumber(value);
    })
    .matches(
      /^09\d{9}$/, // الگو برای شماره موبایل
      'شماره موبایل باید با 09 شروع شده و 11 رقم باشد.'
    )
    .required('شماره موبایل الزامی است.'),
});
